import { FulfillmentPreferenceTypeEnum, StatusEnum } from '@tiendanube/common';
import log from 'commons/logger';
import { OrderStatusType } from '../../pages/OrderDetailsPage/components/commons/useOrderStatus';
import { fulfillment } from '../../pages/OrderListPage/components/commons/Status/status';

export const generateFulfillmentLabel = (
  status: StatusEnum,
  preferenceType: FulfillmentPreferenceTypeEnum,
  t,
) => {
  const fulfillmentLabel = fulfillment(status, preferenceType);

  return {
    ...fulfillmentLabel,
    id: fulfillmentLabel.status,
    label: t(`status.${fulfillmentLabel.status}`, {
      context: 'fulfillmentOrder',
    }),
  };
};

export const getShouldShowInstallments = (
  installments: number,
  methodCode: string,
) => installments > 1 || methodCode === 'credit_card';

export const getLatestPayment = (order: OrderStatusType) => {
  // NOTE: This prevents an error if frontend is receiving an old answer
  try {
    return order.payments[0];
  } catch (error) {
    log({
      message: 'Error getting latest payment',
      error,
      level: 'error',
      location: 'OrderDetailsPage/utils.ts',
      data: {
        order,
      },
    });
    return order.payment;
  }
};
